function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.177 6.167a8.233 8.233 0 0 1 8.351-2.027 1.249 1.249 0 1 0 .76-2.38A10.751 10.751 0 0 0 2.046 16.033a.248.248 0 0 1-.094.3l-1.4.922A1 1 0 0 0 .9 19.071l4.407.908a.99.99 0 0 0 .2.021 1 1 0 0 0 .979-.8l.914-4.406a1 1 0 0 0-1.529-1.037l-1.339.881a.25.25 0 0 1-.376-.133 8.269 8.269 0 0 1 2.021-8.338zM23.883 5.832a1 1 0 0 0-.763-.807l-4.388-1a1 1 0 0 0-1.2.752l-1 4.387a1 1 0 0 0 1.507 1.069l1.443-.906A.247.247 0 0 1 19.7 9.3a.252.252 0 0 1 .153.159A8.249 8.249 0 0 1 9.568 19.883a1.25 1.25 0 1 0-.737 2.388A10.75 10.75 0 0 0 21.985 8a.248.248 0 0 1 .1-.3l1.346-.846a1 1 0 0 0 .452-1.022z"
});

var SvgButtonRefreshArrows = function SvgButtonRefreshArrows(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgButtonRefreshArrows;